import React from 'react';
import { useRouteError, isRouteErrorResponse, Link } from 'react-router-dom';

export default function ErrorPage() {
  const error = useRouteError();
  let title = 'Oops!';
  let message = 'An unexpected error has occurred.';

  if (isRouteErrorResponse(error)) {
    title = `${error.status} ${error.statusText}`;
    message = error.data?.message || message;
  } else if (error instanceof Error) {
    message = error.message;
  }

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h1>{title}</h1>
      <p>{message}</p>
      <Link to="/" style={{ color: '#1890ff' }}>Go to Home</Link>
    </div>
  );
}
